module.exports = __webpack_public_path__ + "static/media/upload.6658c72f.svg";